import { render } from "./chartedit.vue?vue&type=template&id=bda09f4c"
import script from "./chartedit.vue?vue&type=script&lang=js"
export * from "./chartedit.vue?vue&type=script&lang=js"

import "./chartedit.vue?vue&type=style&index=0&id=bda09f4c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__